import { makeDeleteRequest } from './makeRequest';

const deleteWishlist = (data) =>
  makeDeleteRequest('/api/users/self/wishlist', data);

export default deleteWishlist;
